import { TableCell } from '@material-ui/core';
import clsx from 'clsx';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { FunctionComponent, MouseEvent, TouchEvent, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './NotesTableRow.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';

interface NotesTableRowProps {
    notes: string;
    colSpan: number;
    className?: string;
}

export const NotesTableRow: FunctionComponent<NotesTableRowProps> = props => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });

    const [collapsed, setCollapsed] = useState(true);

    const clickHandler = (event: MouseEvent | TouchEvent) => {
        event.nativeEvent?.stopImmediatePropagation();
        event.preventDefault();
        event.stopPropagation();

        setCollapsed(prev => !prev);
    };

    const notMobileRow = (
        <TableRow
            className={clsx(styles.row, props.className)}
            onClick={clickHandler}
        >
            <TableCell
                className={styles.cell}
                colSpan={props.colSpan}
            >
                <div className={styles.container}>
                    <div className={clsx(styles.textContainer, { [styles.collapsed]: collapsed })}>
                        <span className={clsx(styles.text, { [styles.collapsedText]: collapsed })}>
                            <span className={styles.title}>Booking Notes:</span>
                            {props.notes}
                        </span>
                    </div>
                    <div className={styles.chevronContainer}>
                        <FontAwesomeIcon icon={collapsed ? faChevronDown : faChevronUp} />
                    </div>
                </div>
            </TableCell>
        </TableRow>
    );

    const mobileRow = (
        <div
            className={styles.container}
            onClick={clickHandler}
        >
            <div className={clsx(styles.textContainer, { [styles.collapsed]: collapsed })}>
                <span className={clsx(styles.mobileText, { [styles.mobileCollapsedText]: collapsed })}>
                    <span className={styles.title}>Booking Notes:</span>
                    {props.notes}
                </span>
            </div>
            <div className={styles.chevronContainer}>
                <FontAwesomeIcon icon={collapsed ? faChevronDown : faChevronUp} />
            </div>
        </div>
    );

    return isMobile ? mobileRow : notMobileRow;
};

export default NotesTableRow;
